import { render, staticRenderFns } from "./AvatarField.vue?vue&type=template&id=57dcf00c&scoped=true"
import script from "./AvatarField.vue?vue&type=script&lang=js"
export * from "./AvatarField.vue?vue&type=script&lang=js"
import style0 from "./AvatarField.vue?vue&type=style&index=0&id=57dcf00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dcf00c",
  null
  
)

export default component.exports